import "esbuild-css-modules-plugin-ns-css:src/artifacts/auth/styles/form.module.css";

export default {
  "error": "form-module__error_3Zgq_G__010",
  "field": "form-module__field_3Zgq_G__010",
  "form": "form-module__form_3Zgq_G__010",
  "input": "form-module__input_3Zgq_G__010",
  "switch": "form-module__switch_3Zgq_G__010"
};
      